export default __webpack_public_path__ + "resources/icons/d141-b236.png";